module.exports = __webpack_public_path__ + "static/media/home-bg.8c8ada95.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home-bg.png
// module id = 453
// module chunks = 0